import { IAttributeConvert } from "./../../attribute/convert/IAttributeConvert";
import { RoadStructuresBridgesAttributeConvert } from "@/attribute/convert/RoadStructuresBridgesAttributeConvert";
import { FeatureType } from "../define/FeatureType";
import { AbstractRoadStructuresLayerFactory } from "./AbstractRoadStructuresLayerFactory";

/**
 * 点検データ(道路橋)レイヤ 出力クラス
 */
export class RoadStructuresBridgesLayerFactory extends AbstractRoadStructuresLayerFactory {
  /**
   * API取得用URL
   */

  URL_API = process.env.VUE_APP_ROAD_STRUCTURES_DB_API_URL + "/bridges";

  /**
   * アイコンURL
   */

  URL_LAYER_ICON = "./icon/layer/structures-bridges.png";

  /**
   * アイコンのサイズ
   */

  ICON_SIZE = 1;

  /**
   * 最大ズームレベル
   */

  LAYER_MAX_ZOOMLEVEL = 18;

  /**
   * 最小ズームレベル
   */

  LAYER_MIN_ZOOMLEVEL = 11;

  /**
   * コンテキストメニュー名称
   */
  CONTEXT_MENU_NAME = "点検DB_道路橋";

  /**
   * 対象FeatureType
   */
  FEATURE_TYPE = FeatureType.Bridges;

  /**
   * 対象Attribute変換クラス
   */
  ATTRIBUTE_CONVERT = (geoJSON: any) =>
    new RoadStructuresBridgesAttributeConvert(geoJSON) as IAttributeConvert;
}
